// extracted by mini-css-extract-plugin
module.exports = {"footerLinks":"Footer-module--footerLinks--16VlS","footerTop":"Footer-module--footerTop--13l42"};